import Immutable from 'immutable';

import UpdateAction from 'sharedreact/data/UpdateAction';

import ViewSessionsActions from 'workspaces/launcher/actions/ViewSessionsActions';
import ViewSession from 'workspaces/launcher/data/ViewSession';

type ActionType = {
  action: string,
  items: [],
  ids: string[]
};

function _createAction (action: ActionType): UpdateAction {
  return new UpdateAction({
    action: action.action,
    items: action.items ? Immutable.List(action.items.map((item) => ViewSession.fromJS(item))) : Immutable.List(),
    ids: Immutable.List(action.ids)
  });
}

function update (data: any) {
  ViewSessionsActions.update(Immutable.List(data.actions.map((action: ActionType) => _createAction(action))));
}

const ViewSessionListeners = {
  update
};

export default ViewSessionListeners;
